import React, { useState } from "react";
import axios from "axios";
import Nav from "./Nav";
import Footer from "./Footer";
import "./application.css";

export default function Application() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [postcode, setPostcode] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [position, setPosition] = useState([]);
  const [site, setSite] = useState([]);
  const [availability, setAvailability] = useState([]);
  const [about, setAbout] = useState("");
  const [message, setMessage] = useState("");
  const [cv, setCv] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [degreeStatus, setDegreeStatus] = useState("");
  const [degreeName, setDegreeName] = useState("");

  const submission = async (e) => {
    e.preventDefault();
    setIsSending(true);
    const data = new FormData();
    const candidate = {
      store: site,
      position: position,
      availability: availability,
      name: name,
      address: address,
      city: city,
      postcode: postcode,
      email: email,
      phone: phone,
      about: about,
      education: {
        status: degreeStatus,
        name: degreeName,
      },
      cv: cv,
    };
    const json = JSON.stringify(candidate);
    data.append("file", cv);
    data.append("candidate", json);
    if (cv === "") {
      setMessage("Error Submitting Your Application. You Must Attach Your CV.");
      setIsSending(false);
      setTimeout(() => {
        setMessage("");
      }, 2500);
    } else {
      setMessage(
        "We are now sending your application. Please wait as this may take a couple of minutes.",
      );
      await axios
        .post("https://nitrous.rt-itservices.co.uk/racetrack/apply", data)
        .then((res) => {
          setMessage("");
          alert("Application has been submitted");
          window.location.reload();
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.error(err);
          }
          setIsSending(false);
        });
    }
  };
  const siteOptions = [
    "Autoport",
    "Bearsden",
    "Braeside",
    "Bridgeton",
    "Coatbridge",
    "Crowwood",
    "Dumbarton Rd",
    "Rutherglen",
    "Sauchiehall",
    "St James Rd",
    "Wishaw",
  ];

  const positionOptions = [
    "Customer Service Assistant",
    "Supervisor",
    "Manager",
    "Delivery Driver",
  ];

  const availabilityOptions = ["Full-time", "Part-time"];

  return (
    <div className="application-page">
      <Nav />
      <main className="application-main">
        <div className="application-heading">
          <span>Join the team</span>
          <h1>Job Application Form</h1>
          <p>Tell us about yourself, then let us know where you would like to work.</p>
        </div>

        <form className="application-form" onSubmit={submission}>
          <section className="application-card">
            <div className="application-card-heading">
              <span>01</span>
              <div>
                <h2>Your details</h2>
                <p>How can we contact you?</p>
              </div>
            </div>

            <div className="application-fields">
              <label>
                Name
                <input
                  type="text"
                  placeholder="Your full name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </label>
              <label>
                Email address
                <input
                  type="email"
                  placeholder="you@example.com"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
              <label>
                Phone number
                <input
                  type="tel"
                  placeholder="Your phone number"
                  required
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </label>
              <label>
                Address
                <input
                  type="text"
                  placeholder="Your address"
                  required
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </label>
              <label>
                City
                <input
                  type="text"
                  placeholder="Your city"
                  required
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
              </label>
              <label>
                Postcode
                <input
                  type="text"
                  placeholder="Your postcode"
                  required
                  value={postcode}
                  onChange={(e) => setPostcode(e.target.value)}
                />
              </label>
            </div>
          </section>

          <section className="application-card">
            <div className="application-card-heading">
              <span>02</span>
              <div>
                <h2>Role preferences</h2>
                <p>Select all options that apply.</p>
              </div>
            </div>

            <fieldset>
              <legend>Preferred site</legend>
              <div className="application-options">
            {siteOptions.map((siteOption) => (
              <label key={siteOption} className="application-option">
                <input type="checkbox" value={siteOption} required={site.length === 0} checked={site.some((s) => s === siteOption)} onChange={(e) => e.target.checked ? setSite([...site, siteOption]) : setSite(site.filter((s) => s !== siteOption))} />
                <span>{siteOption}</span>
              </label>
            ))}
              </div>
            </fieldset>

            <fieldset>
              <legend>Position</legend>
              <div className="application-options application-options-inline">
            {positionOptions.map((positionOption) => (
              <label key={positionOption} className="application-option">
                <input type="checkbox" required={position.length === 0} value={positionOption} checked={position.some((p) => p === positionOption)} onChange={(e) => e.target.checked ? setPosition([...position, positionOption]) : setPosition(position.filter((p) => p !== positionOption))} />
                <span>{positionOption}</span>
              </label>
            ))}
              </div>
            </fieldset>

            <fieldset>
              <legend>Availability</legend>
              <div className="application-options application-options-inline">
            {availabilityOptions.map((availabilityOption) => (
              <label key={availabilityOption} className="application-option">
                <input type="checkbox" required={availability.length === 0} value={availabilityOption} checked={availability.some((a) => a === availabilityOption)} onChange={(e) => e.target.checked ? setAvailability([...availability, availabilityOption]) : setAvailability(availability.filter((a) => a !== availabilityOption))} />
                <span>{availabilityOption}</span>
              </label>
            ))}
              </div>
            </fieldset>
          </section>

          <section className="application-card">
            <div className="application-card-heading">
              <span>03</span>
              <div>
                <h2>Your experience</h2>
                <p>Share a little more about your background.</p>
              </div>
            </div>
            <div className="application-fields application-fields-single">
              <label>
                Education / degree
                <select value={degreeStatus} onChange={(e) => setDegreeStatus(e.target.value)} required>
            <option value="">Select an option</option>
            <option value="N/A">Not applicable (N/A)</option>
            <option value="Studying">
              Currently studying at university/college
            </option>
            <option value="Completed">Completed a degree</option>
          </select>
                {degreeStatus !== "N/A" && degreeStatus !== "" && (
                  <input
                    type="text"
                    placeholder="e.g. BA Business, HND Accounting"
                    value={degreeName}
                    onChange={(e) => setDegreeName(e.target.value)}
                    required
                  />
                )}
              </label>
              <label>
                Why work for RaceTrack?
                <textarea
                  placeholder="Tell us why you would like to work for RaceTrack Pitstop."
                  rows="5"
                  value={about}
                  onChange={(e) => setAbout(e.target.value)}
                />
              </label>
            </div>
          </section>

          <section className="application-card application-submit-card">
            <label className="application-upload">
              <span>Upload your CV (PDF)</span>
              <input
                className="cv"
                type="file"
                name="cv"
                accept=".pdf"
                onChange={(e) => setCv(e.target.files[0])}
              />
            </label>
            {message && <p className="application-message">{message}</p>}
            <button disabled={isSending} type="submit">
            Submit
            </button>
          </section>
        </form>
      </main>
      <Footer />
    </div>
  );
}
